export default "__VITE_ASSET__1vcJzecc__"